module.exports = __webpack_public_path__ + "img/clubcard-online.346c76ea.png";